import * as moment from "moment";


export class Globals {
  static readonly maxTime = moment('9999-12-31 00:00:00');
  static readonly minTime = moment('1970-01-01 00:00:00');
}
